import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const SketchPanelExtensionContainer = styled(Box)`
  border-left: 1px solid var(--calcite-color-border-1);
  display: contents;
`;
